import React from 'react';
// import SarasDnDList from '../../../../library/hooks/bdnd/SarasDnDList';
import SarasDnDList from '../../../../library/hooks/dndkit/SarasDnDList';
import ColumnSelectorCol from './ColumnSelectorCol'

const ColumnSelectorDNDList = (props) => {
    const { groupKey, viewData, rowKeys, sarasDnDManager, onToggleVisibility, isHidden } = props;

    const renderDnDRow = (row, index) => {
        let rowData = viewData.columns[row.columnKey];

        return (
            <ColumnSelectorCol index={index} rowKey={row.columnKey}
                viewData={rowData} key={row.columnKey}
                isHidden={isHidden}
                onToggleVisibility={onToggleVisibility}
                groupKey={1} isSortMode={sarasDnDManager.isSortMode()}
            />
        )
    }

    return (
        <SarasDnDList groupKey={groupKey} sarasDnDManager={sarasDnDManager} >
            {
                rowKeys && rowKeys.map((row, index) => (
                    renderDnDRow(row, index)
                ))
            }
        </SarasDnDList>
    )
}

export default ColumnSelectorDNDList
